import Image from 'next/image';
import type { Dictionary } from 'types';
import type { VariantAttribute, VariantState } from 'types/variant';

export default function ProductPageVariantSelectButton({
    selection,
    label,
    options,
    dictionary,
}: {
    selection: VariantState['selection'][0];
    label: string;
    options: Map<string, VariantAttribute[]>;
    dictionary: Dictionary;
}) {
    if (!selection) {
        return (
            <div className="flex flex-row items-center self-stretch">
                <ProductPageVariantChooseVariant
                    dictionary={dictionary}
                    label={label}
                />
            </div>
        );
    }

    const variants = [...options];
    const variant = variants.find(([key]) => key === selection)?.[1]?.[0];

    if (!variant) {
        return selection;
    }

    return (
        <div className="flex flex-row items-center self-stretch">
            <ProductPageVariantSelectedVariant variant={variant} />
        </div>
    );
}

function ProductPageVariantChooseVariant({
    dictionary,
    label,
}: {
    dictionary: Dictionary;
    label: string;
}) {
    return (
        <span className="mx-4">
            {dictionary.chooseAttribute?.replace('%', label.toLowerCase())}
        </span>
    );
}

function ProductPageVariantSelectedVariant({
    variant,
}: {
    variant: VariantAttribute;
}) {
    return (
        <>
            {variant.swatch && (
                <Image
                    className="aspect-square h-full w-auto object-cover"
                    src={variant.swatch}
                    alt={variant.label}
                    width={48}
                    height={48}
                    sizes="48px"
                />
            )}
            <span className="mx-4">{variant.label}</span>
        </>
    );
}
